import { Check } from "lucide-react";
import {
    FOOTER_SERVICES, FOOTER_SOLUTIONS, FRAMEWORKS, FOOTER_ABOUT, LEGAL,
    FOOTER_CTA, PORTAL_REGISTER, LOGO,
} from "./gdprData";

const Col = ({ title, items }) => (
    <div>
        <h4 className="text-sm font-bold text-white mb-3">{title}</h4>
        <ul className="space-y-2">
            {items.map((it) => (
                <li key={it.label}>
                    <a href={it.href} className="text-sm text-white/70 hover:text-aqua transition-colors">{it.label}</a>
                </li>
            ))}
        </ul>
    </div>
);

export const Footer = () => (
    <footer className="bg-asphalt text-white" data-testid="site-footer">
        {/* CTA band */}
        <div className="border-b border-white/10">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
                <div className="max-w-2xl">
                    <h2 className="text-2xl sm:text-3xl font-bold text-white">{FOOTER_CTA.heading}</h2>
                    <p className="mt-3 text-white/70 text-base">{FOOTER_CTA.subtext}</p>
                    <div className="mt-4 flex flex-wrap gap-5">
                        <span className="flex items-center gap-2 text-sm text-white/80"><Check className="w-4 h-4 text-aqua" /> No credit card required</span>
                        <span className="flex items-center gap-2 text-sm text-white/80"><Check className="w-4 h-4 text-aqua" /> Easy setup</span>
                    </div>
                </div>
                <a href={PORTAL_REGISTER} data-testid="footer-signup"
                    className="shrink-0 px-6 py-3 rounded-md bg-aqua text-asphalt font-medium hover:brightness-95 transition-all">
                    Sign up free
                </a>
            </div>
        </div>

        {/* columns */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14">
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8">
                <div className="col-span-2 md:col-span-1">
                    <img src={LOGO} alt="GDPR Local" className="h-9 w-auto brightness-0 invert mb-4" />
                    <p className="text-sm text-white/70">GDPRLocal Ltd, UK Reg: 12969035</p>
                    <p className="text-sm text-white/70 mt-2">1st Floor Front Suite, 27-29 North Street, Brighton, England, BN1 1EB</p>
                </div>
                <Col title="Services" items={FOOTER_SERVICES} />
                <Col title="Solutions" items={FOOTER_SOLUTIONS} />
                <Col title="Frameworks" items={FRAMEWORKS} />
                <Col title="About us" items={FOOTER_ABOUT} />
            </div>
        </div>

        {/* bottom bar */}
        <div className="border-t border-white/10">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
                <p className="text-sm text-white/60">GDPRLocal 2026 &copy; All Rights Reserved</p>
                <div className="flex flex-wrap gap-x-5 gap-y-2 justify-center">
                    {LEGAL.map((it) => (
                        <a key={it.label} href={it.href} className="text-sm text-white/60 hover:text-aqua transition-colors">{it.label}</a>
                    ))}
                </div>
            </div>
        </div>
    </footer>
);
